<template>
  <SfModalPortal modal-id="reset-check-list-confirmation-modal" :size="'xs'">
    <template #title>
      {{ I18n.t('check_lists.reset_confirmation_modal.title') }}
    </template>

    <template #body>
      <div>
        {{ I18n.t('check_lists.reset_confirmation_modal.body') }}
      </div>
    </template>

    <template #footer>
      <SfButtonDs @click="handleCancel">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
      <SfButtonDs variant="danger" @click="handleSuccess">
        {{ I18n.t('check_lists.reset_confirmation_modal.confirm') }}
      </SfButtonDs>
    </template>
  </SfModalPortal>
</template>

<script lang="ts" setup>
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import { SfButtonDs } from '@silverfin/ui-components'

const I18n = window.I18n

const handleCancel = () => {
  window.modalCitizen.closeModalPortal()
}

const handleSuccess = () => {
  window.modalCitizen.closeModalPortal()
  window.eventHub.$emit('reset-check-list-confirmed')
}
</script>
